

export default function zeitInDezimal(zeitString) {
 
    // Entferne eventuell vorhandene Leerzeichen
    zeitString = zeitString.trim();

    // Entferne das Wort "Uhr" falls vorhanden
    //zeitString = zeitString.replace(/Uhr/i, "").trim();

    // Teile die Uhrzeit in Stunden und Minuten
    const teile = zeitString.split(":");
    if (teile.length !== 2) {
        throw new Error("Ungültiges Format, bitte im Format HH:MM angeben");
    }

    const stunden = parseInt(teile[0], 10);
    const minuten = parseInt(teile[1], 10);

    if (isNaN(stunden) || isNaN(minuten)) {
        throw new Error("Ungültige Zahlen in der Uhrzeit");
    }

    // Rechne Minuten in Dezimalstunden um
    const dezimalMinuten = minuten / 60;

    // Addiere Stunden und Dezimalminuten
    const dezimalZeit = stunden + dezimalMinuten;

    return dezimalZeit;
}

// Beispiel:

